import React, {Component} from 'react'
import {
    Card,
    Table,
    Button,
    Tag,
} from 'antd';
import {getScoreList} from '../../../request'
import {withRouter} from "react-router-dom";

let columnsKey = {
    periodName: '周期',
    userNick: '被评人',
    projectName:'问卷名称',
    createTime:'问卷下发',
    endTime:'问卷结束',
    status:'状态',
    avgScore:'平均分',
    score:'分数',
    actions: '操作',
}
class ScoreList extends Component {
    state = {
        dataSource:[],
        columns:[],
    };
    createColumns = (createKeys)=>{
        let columns = Object.keys(createKeys).map(item=>{
            let initObj = {
                title:createKeys[item],
                dataIndex:item,
                key:item,
                align:'left'
            }
            if(item=='status'){
                return {
                    ...initObj,
                    width: 60,
                    render:(text,record,index)=>{
                        return(
                            text==3?
                            <Tag color="purple">已汇算</Tag>
                                :
                                (text==2?<Tag color="geekblue">已评分</Tag>
                                    :
                                        (text==1?<Tag color="lime">已下发</Tag>:<Tag color="pink">待下发</Tag>))
                        )
                    }
                }
            }else if(item=='refType'){
                return {
                    ...initObj,
                    render:(text,record,index)=>{
                        return(
                            text==1? 'peers' : (text==2?'leader' : (text==3?'下级':'自己'))
                        )
                    }
                }
            }else if(item=='actions'){
                return {
                    ...initObj,
                    fixed: 'right',
                    width: 100,
                    render: (text, record, index) => {
                        return (
                            <>
                                {
                                        <>
                                            <Button type="link" size="small"
                                                    onClick={() => (this.toScorePage(record))}>{record.status>1?'查看':'去评分'}</Button>

                                        </>

                                }
                            </>
                        )
                    }
                }
            }else{
                return initObj
            }
        })
        this.setState({
            columns,
        })
    }
    initTableDataList(){
        this.setState({ loading: true });
        getScoreList({}).then(res=>{
            this.setState({
                loading: false,
                dataSource:res,
                total:res.total
            })
        })
    }
    toScorePage = (values)=>{
        console.log(values)
        // this.props.history.push({
        //     pathname:values.projectUrl
        // })
        window.open(values.projectUrl,'_blank')
    }
    componentDidMount(){
        console.log(this.props.history)
        this.createColumns(columnsKey);
        this.initTableDataList()
    }
    render() {

        const { dataSource,columns, loading} = this.state;

        return (
            <>
                <Card title={<span>评分列表</span>} bordered={false} className={'card-fixed-head-wrap'}>
                    <Table
                        bordered
                        size="small"
                        pagination={false}
                        dataSource={dataSource}
                        columns={columns}
                        rowKey={record=>record.id}
                        loading={loading}
                    />
                </Card>
            </>

        )
    }
}
export default withRouter(ScoreList)